@if (!isFreeText && clarify.options?.length) {
  @if (isCollapsed) {
    <div class="text-xs text-base-content/60 mt-1 ml-1">✓ {{ selectedLabel }}</div>
  } @else {
    <div class="flex flex-wrap gap-2 mt-2 ml-1">
      @for (option of clarify.options; track option.index) {
        <button
          type="button"
          class="btn btn-sm btn-outline gap-2"
          (click)="select(option)"
        >
          @if (option.thumb_url) {
            <img [src]="option.thumb_url" class="w-5 h-5 rounded object-cover" alt="" />
          }
          <span>{{ option.label }}</span>
        </button>
      }
    </div>
  }
}
